import { Engineering, NavigateNext } from '@mui/icons-material';
import {
    Avatar,
    Box,
    Card,
    CardContent,
    MenuItem,
    Paper,
    Select,
    Typography,
    useTheme,
} from '@mui/material';
import React, { useState } from 'react';
import { Period } from '../../../enums/reports';
import { useNavigate } from 'react-router';
import { useGetReportQuery } from '../../../../app/Slices/SevenDayApiSlice';
import SkeletonLayout from './SkeletonLayout';

const JobsCard = () => {
    const navigate = useNavigate();
    const [period, setPeriod] = useState(Period.CurrentWeek);

    const { data: jobs } = useGetReportQuery(
        `/dashboard/scheduled-jobs?period=${period}`,
    );

    const theme = useTheme();

    return (
        <Paper elevation={0}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant='subHeading' sx={{ lineHeight: 2 }}>
                    Contractors
                </Typography>
                <Select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value as Period)}
                    size='small'
                    sx={{ fontSize: '14px' }}
                >
                    <MenuItem value={Period.Today}>Today</MenuItem>
                    <MenuItem value={Period.Tomorrow}>Tomorrow</MenuItem>
                    <MenuItem value={Period.CurrentWeek}>This Week</MenuItem>
                    <MenuItem value={Period.NextWeek}>Next Week</MenuItem>
                    <MenuItem value={Period.CurrentMonth}>This Month</MenuItem>
                </Select>
            </Box>
            <Card sx={{ mt: 1, cursor: 'pointer' }}>
                <CardContent
                    onClick={() =>
                        navigate(`/dashboard/scheduled-jobs?period=${period}`)
                    }
                    sx={{ m: 1 }}
                >
                    {jobs ? (
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: 1,
                                }}
                            >
                                <Avatar
                                    variant='rounded'
                                    sx={{
                                        height: 25,
                                        width: 25,
                                        bgcolor: theme.palette.neutral.main,
                                        color: 'text.primary',
                                    }}
                                >
                                    <Engineering fontSize='small' />
                                </Avatar>
                                <Typography sx={{ fontWeight: 'bold' }}>
                                    Scheduled Jobs
                                </Typography>
                                <NavigateNext />
                            </Box>
                            <Typography
                                sx={{ fontSize: '3rem', fontWeight: 'bold' }}
                            >
                                {jobs.length}
                            </Typography>
                        </>
                    ) : (
                        <SkeletonLayout />
                    )}
                </CardContent>
            </Card>
        </Paper>
    );
};

export default JobsCard;
